<template>
    <div class="published-counter float-left">
        <div >
            <h3 class="mr-3">Published >
                <date-picker
                    updateOnInput
                    ref="calendar"
                    v-model="dates"
                    mode="range"
                    :popover="{ placement: 'bottom', visibility: 'click' }"
                    @input="changeDateEvent"
                >
                    <button
                        class="btn btn-outline-secondary dates-btn"
                        v-bind:class="{ active: hasDates }"
                    >
                        <span v-if="hasDates">{{ dateFrom }} - {{ dateTo }}</span>
                        <fa-icon v-else icon="calendar-alt"></fa-icon>
                    </button>
                </date-picker>

                <button
                    class="btn btn-link text-muted"
                    v-if="hasDates"
                    v-on:click="deleteDates"
                >
                    <fa-icon icon="times-circle"></fa-icon>
                </button>
            </h3>
            <h4 class="mr-3">
                <span
                    class="modal-toggler"
                    data-toggle="modal"
                    data-target="#storyModal"
                >
				Docus: {{ published }}
                | Episodes: {{ episodes }}
			</span>
                | Duration: {{ duration }}
            </h4>


        </div>
        <!-- Stories modal -->
        <div
            class="modal fade"
            id="storyModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="storyModalTitle"
            aria-hidden="true"
            v-if="stories && stories.length > 0"
        >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="storyModalTitle">
                            Published docus
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table story-listing">
                            <thead class="thead-light">
                            <tr>
                                <th scope="col">Title</th>
                                <th scope="col">Duration</th>
                                <th scope="col">Type</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr
                                v-for="(story, index) in stories"
                                :key="index"
                            >
                                <td>
                                    <a :href="`/docus/${story.id}/edit`">
                                        {{ story.title }}
                                    </a>
                                </td>
                                <td class="compact">
                                    {{ story.duration }}
                                </td>
                                <td class="compact">{{ story.type }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import moment from "moment";

export default {
    data() {
        return {
            published: 0,
            episodes: 0,
            duration: "00:00",
            stories: [],
            dates: {
                start: null,
                end: null,
            },
        };
    },
    methods: {
        fetchData() {
            axios
                .get(`stories/published${this.getDateQuery()}`)
                .then((response) => {
                    this.published = response.data ? response.data.count : 0;
                    this.episodes = response.data ? response.data.episodes_count : 0;
                    this.duration = response.data
                        ? this.parseDuration(response.data.duration)
                        : "00:00";
                    this.stories = response.data ? response.data.stories : [];
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        getDateQuery() {
            if (this.hasDates) {
                return `?from=${this.dateFrom}&to=${this.dateTo}`;
            }

            return "";
        },
        changeDateEvent() {
            this.fetchData();
        },
        deleteDates() {
            this.$set(this.dates, "start", null);
            this.$set(this.dates, "end", null);
            this.changeDateEvent();
        },
        parseDuration(duration) {
            const hours = _.floor(duration / 3600);
            const minutes = _.padStart(_.floor((duration % 3600) / 60), 2, "0");

            if (hours) return `${hours}:${minutes}`;
            return `00 : ${minutes}`;
        },
    },
    computed: {
        hasDates() {
            return (this.dates && this.dates.start && this.dates.end);
        },
        dateFrom() {
            return moment(this.dates.start).format("YYYY-MM-DD");
        },
        dateTo() {
            return moment(this.dates.end).format("YYYY-MM-DD");
        },
    },
    components: {
        DatePicker,
    },
    mounted() {
        this.fetchData();
    },
};
</script>

<style scoped lang="scss">
.modal-toggler {
    cursor: pointer;

    &:hover {
        color: #3490dc;
    }
}
</style>
